export default __webpack_public_path__ + "static/Plots0021-26969e0c06d1c49d7e101b45f5ff4b8f.jpg";